import React, { useEffect, useState } from 'react';

interface ICustomTableProps {
  value: string;
}

const CustomTableCell: React.FC<ICustomTableProps> = ({
  value: initialValue,
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <div className="group flex items-center justify-between relative min-h-6">
      <p className="bg-transparent mr-px overflow-hidden text-black dark:text-[#d3ddec] break-all">
        {value}
      </p>
    </div>
  );
};

export default CustomTableCell;
